import store from "@/store";

const subscribeFilterTabs = (stompClient) => {
  stompClient.subscribe("/user/topic/filter", (message) => {
    try {
      if (!message || store.getters["impersonalization/mindControlledUser"]) {
        return;
      }

      const payload = JSON.parse(message.body);

      store.dispatch("filterTabs/updateFilterTab", payload);
    } catch (e) {
      console.error(e);
    }
  });
};

export default subscribeFilterTabs;
